"use strict";
'use strict';

var blockquote = require('./blockquote.cjs');



exports.Caption = blockquote.BlockquoteCaption;
exports.Content = blockquote.BlockquoteContent;
exports.Icon = blockquote.BlockquoteIcon;
exports.PropsProvider = blockquote.BlockquotePropsProvider;
exports.Root = blockquote.BlockquoteRoot;
